import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";

import imgAboutP from "../../assets/image/l5/png/l5-about-pattern.png";
import imgAboutB from "../../assets/ecom/shopify_hand.png";
import imgAboutM from "../../assets/ecom/warehouse.png";
import imgAboutS from "../../assets/ecom/laptop_web_development.png";

const Content1 = ({ data }) => (
  <>
    {/* <!-- Content section 1 --> */}
    <div
      id="about-us"
      className="content-section bg-default-4 pt-lg-25 pt-15 pb-10 pb-lg-15"
    >
      <Container>
        <Row>
          <Col xl="10" lg="9" md="8">
            <div className="section-title mb-13">
              <h4 className="pre-title gr-text-17 text-red text-uppercase mb-9">
                {data.about_us_section_heading.text}
              </h4>
              <h2 className="title gr-text-4">
                {data.about_us_quote.text} {" "}
              </h2>
              <br />
              <h4 className="pre-title gr-text-19 text-grey text-uppercase mb-9">
                {data.about_us_sub_heading.text}
              </h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="5">
            <div
              className="about-image img-big pt-lg-13"
              data-aos="fade-right"
              data-aos-duration="800"
            >
              <img className="w-100 rounded-10 mt-n10" src={imgAboutB} alt="" />
            </div>
          </Col>
          <Col lg="7">
            <Row className="justify-content-between align-items-center pl-lg-13">
              <Col xl="10">
                <div className="about-content mt-10 mt-lg-0">
                  <p className="gr-text-30">
                    <div dangerouslySetInnerHTML={{
                      __html: `
    ${data.about_us_paragraph.html}`
                    }}
                    />
                  <Link
                    to="/#enquire-now"
                    className="btn rounded-8 gr-hover-y btn-top btn_green"
                  >
                    {data.cta_button_text.text}
                  </Link>

                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  </>
);

export default Content1;
